// @flow
import React from "react";
import { FormGroup, Label, Col, Input } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { updateField } from "../../../../redux/actions/configActions";

export default function ModeSelection() {
  // This is a special handler for when the setting field is changed.
  // It's different from a regular field change because it resets the rest

  const config = useSelector(state => state.configReducer.config);
  const dispatch = useDispatch();

  function handleSettingChange(event) {
    event.persist();
    dispatch(
      updateField({
        setting: event.target.value,
        photoRatio: 1
      })
    );
  }
  return (
    <FormGroup row>
      <Label for="setting" sm={2}>
        Mode
      </Label>
      <Col sm={10}>
        <Input
          required
          value={config.setting}
          type="select"
          name="setting"
          id="setting"
          className="dropdown-black"
          onChange={handleSettingChange}
        >
          <option value="" selected={!config.setting} disabled>
            -- Select a mode --
          </option>
          <option value="1">Plain photo</option>
          <option value="2">GIF</option>
          <option value="3">Boomerang</option>
          <option value="4">Augmented reality</option>
          <option value="5">Green screen</option>
          <option value="6">Mosaic</option>
          <option value="7">Slow motion</option>
          <option value="8">Monnayeur</option>
        </Input>
      </Col>
    </FormGroup>
  );
}



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/config-form-subsections/ModeSelection.jsx